import reducerNamespace from '../../FormRenderer/constants/reducerNamespace';
import reducer from '../reducers';
import epics from '../epics';

const createComponentInterface = (store) => ({
    reducerNamespace,
    reducer,
    epics,
});

export default createComponentInterface;
